import { IBackgroundColor } from "../../gatsby-graphql"

export default function getBackground (background: IBackgroundColor) {
  let result = ""
  if (background.singleColor) {
    result = background.singleColor
  }
  if (background.gradientStart && background.gradientEnd) {
    result = `linear-gradient(0deg, ${background.gradientStart} 0%, ${background.gradientEnd} 100%)`
  }
  return result
}
